import React from "react";
import "../index.css"

export default class DefaultBtn extends React.Component{
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.props.handleClick(this.props.plus)
  }

  render() {
    const priceEl = this.props.type === "btn-shop"
      ? (<span className="price">{this.props.plus.price}</span>)
      : ""
    return (
      <button 
        type="button" 
        className={"btn " + this.props.type || ""}
        onClick={this.handleClick}
        disabled={this.props.disabled}>
          {priceEl}
          {this.props.inner}
      </button>
    )
  }
}